import { render, staticRenderFns } from "./Preloader2.vue?vue&type=template&id=36cd8d25&scoped=true&"
import script from "./Preloader2.vue?vue&type=script&lang=js&"
export * from "./Preloader2.vue?vue&type=script&lang=js&"
import style0 from "./Preloader2.vue?vue&type=style&index=0&id=36cd8d25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd8d25",
  null
  
)

export default component.exports